import { AdminOAuthTable } from '../views/index';
import { OAuthClients } from '../dtos/index';

export const ADMIN_OAUTH_LIST_TABLE = (
	oAuthClientList: Array<OAuthClients> = []
): Array<AdminOAuthTable> => {
	let results: Array<AdminOAuthTable> = [];
	if (oAuthClientList.length > 0) {
		oAuthClientList.map((client) => {
			let row = {} as AdminOAuthTable;
			row.accessTokenValidity = client.accessTokenValidity;
			row.authorities = client.authorities;
			row.authorizedGrantTypes = client.authorizedGrantTypes;
			row.cliendId = client.id;
			row.clientSecret = client.clientSecret;
			row.refreshTokenValidity = client.refreshTokenValidity;
			row.resourceIds = client.resourceIds;
			row.scope = client.scope;
			row.clientName = client.clientId;
			row.webServerRedirectURI = client.webServerRedirectUri;
			results.push(row);
		});
	}
	return results;
};
